function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3467 19.034H2.65369C1.74169 19.034 0.975695 18.285 0.975695 17.377V2.623C0.975695 1.72 1.73669 0.966 2.65369 0.966H10.0487V4.019C10.0487 5.193 11.0047 6.135 12.1907 6.135H15.0247V17.377C15.0247 18.285 14.2637 19.034 13.3467 19.034ZM11.0247 1.705L14.3567 5.169H12.1907C11.5467 5.169 11.0247 4.657 11.0247 4.019V1.705ZM10.8827 0.155C10.7897 0.058 10.6627 0 10.5327 0H2.65369C1.20069 0 -0.000305176 1.183 -0.000305176 2.623V17.377C-0.000305176 18.816 1.20069 20 2.65369 20H13.3467C14.7997 20 15.9997 18.816 15.9997 17.377V5.661C15.9997 5.536 15.9417 5.415 15.8587 5.324L10.8827 0.155Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4531 16.9998H2.54112C2.24412 16.9998 2.00012 17.2248 2.00012 17.4998C2.00012 17.7748 2.24412 17.9998 2.54112 17.9998H11.4591C11.7561 17.9998 12.0001 17.7748 12.0001 17.4998C12.0001 17.2248 11.7561 16.9998 11.4531 16.9998Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2441 8.00364C12.0371 7.79664 11.6991 7.79664 11.4921 8.00364L6.6271 12.8686L4.5071 10.7496C4.4071 10.6496 4.2741 10.5936 4.1321 10.5936C3.9901 10.5936 3.8571 10.6496 3.7561 10.7496C3.6561 10.8506 3.6001 10.9836 3.6001 11.1256C3.6001 11.2676 3.6561 11.3996 3.7561 11.5006L6.2511 13.9956C6.4521 14.1966 6.8011 14.1966 7.0021 13.9956L12.2441 8.75464C12.4511 8.54764 12.4511 8.21164 12.2441 8.00364Z",
  fill: "white"
});

var SvgFileCompleteIcon = function SvgFileCompleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileCompleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file_complete_icon.2ea863a9.svg";
export { ForwardRef as ReactComponent };